import React, { Component } from 'react';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HeadContainer, InputCol, LevelRowContainer, MainWrapper, RoundedWrapper } from './styles';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { Label } from 'components/atoms/Texts/TxtLabel';
import { getLookup } from 'Redux/actions/LookupActions';
import FormTxt from 'components/atoms/Inputs/FormTxt';
import moment from 'moment';
import { DateInput } from 'components/molecules/DateTimeInput/index';

export class ActualLoadingSummaryLossTimeForm extends Component {
  onChange(field, val) {
    const { form: { summaryLossTime }, onChange } = this.props
    summaryLossTime[field] = field === 'date' ? moment(val).format() : val
    onChange('summaryLossTime', summaryLossTime)
  }

  renderTextInput(label, key, placeholder, inputProps) {
    const { form: { summaryLossTime }, theme } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px'
    }

    return (
      <InputCol>
        <Label lineheight={'14px'} size={'12px'}>
          {label}
        </Label>
        <FormTxt
          placeholder={placeholder}
          mb={'16px'}
          value={summaryLossTime ? summaryLossTime[key] : ''}
          onChangeVal={e => this.onChange(key, e.target.value)}
          {...inputConfig}
          {...inputProps}
        />
      </InputCol>
    )
  }

  renderDateTimeInput(label, key) {
    const { form: { summaryLossTime }, theme } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 25px',
      height: '34px',
      marginBottom: '16px'
    }

    return (
      <InputCol>
        <Label lineheight={'14px'} size={'12px'}>
          {label}
        </Label>
        <DateInput
          val={summaryLossTime ? (summaryLossTime[key] && new Date(summaryLossTime[key]) ) : new Date()}
          fn={(date, field) => this.onChange(field, moment(date).format())}
          field={key}
          config={inputConfig}
        />
      </InputCol>
    )
  }

  render() {
    return (
        <RoundedWrapper gap="20px">
          <MainWrapper>
            <HeadContainer>
              <Label lineheight={'29px'} size={'16px'} mb={'0px'}>
                Summary Loss Time in {` `}
                <Label lineheight={'29px'} size={'16px'} mb={'0px'} color={this.props.theme.mocaOrange}>
                  {moment(this.props.filter.loadingDate).format('MMM YYYY')}
                </Label>
              </Label>
            </HeadContainer>
              <LevelRowContainer isTop>
                {this.renderDateTimeInput('Date', 'date')}
                {this.renderTextInput('Loss Time', 'lossTime', 'Enter loss time' )}
              </LevelRowContainer>
          </MainWrapper>
        </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      getLookup
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActualLoadingSummaryLossTimeForm)
  )
);
